import * as vp from 'vopay';
import { FunctionComponent, useState } from 'react';
import ContactForm from './ContactForm';
import ContactsTable from './ContactsTable';
import BulkTransactionReview from './BulkTransactionReviewTable';
import { useTranslation } from 'react-i18next';

const { Box, SubTitle } = vp;

type ContactListType = {
  [key: number]: {
    Account: string;
    Amount: string;
    ClientReferenceNumber: string;
    Currency: string;
    FirstName: string;
    IsActive: string;
    LastName: string;
    Message: string;
    Token: string;
    AccountHolderName: string;
    ContactID: string;
  };
};

type ContactsProps = {
  group: vp.ContactGroupsLists;
  groupID: string;
  isReview: boolean;
  groupList: ContactListType;
  type: string;
  handleReview: (e: boolean) => void;
  handleTransactionDetail: (e: boolean) => void;
  handleList: (list: ContactListType) => void;
};

type FC = FunctionComponent<ContactsProps>;

const GroupContactsContainer: FC = (props: ContactsProps) => {
  const { group, groupID, isReview, groupList, type, handleReview, handleTransactionDetail, handleList } = props;
  const [hasNewContacts, setHasNewContactsList] = useState(false);
  const { t } = useTranslation('translations', { keyPrefix: 'Groups.Details.Contacts' });

  return (
    <Box flx="col">
      {isReview ? <></> : <SubTitle subTitle={type === 'Payment' ? t('payeeSubTitle') : t('payerSubTitle')} />}
      <Box flx="col">
        {isReview ? (
          <></>
        ) : (
          <ContactForm
            groupID={groupID}
            type={type}
            groupList={groupList}
            setHasNewContactsList={setHasNewContactsList}
          />
        )}
        {isReview ? (
          <BulkTransactionReview
            groupList={groupList}
            group={group}
            type={type}
            handleReview={handleReview}
            handleTransactionDetail={handleTransactionDetail}
            handleList={handleList}
          />
        ) : (
          <ContactsTable
            groupList={groupList}
            group={group}
            groupID={groupID}
            type={type}
            hasNewContacts={hasNewContacts}
            isReview={isReview}
            setHasNewContactsList={setHasNewContactsList}
            handleReview={handleReview}
            handleList={handleList}
          />
        )}
      </Box>
    </Box>
  );
};

export default GroupContactsContainer;
